import { SET_USER_PROFILE } from "./types";
import { AdminRole } from "@trnsact/trnsact-shared-types";

const initialState = {};

export const userProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_PROFILE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const checkIfUserIsSuperAdmin = state =>
  [AdminRole.Super, AdminRole.SingleAccountOnly].includes(state.userProfile.adminRole);

export const userSelectors = {
  checkIfUserIsSuperAdmin,
};
